// Shared style map for attendance statuses across Student Detail subcomponents.
export const STATUS_STYLES = {
    Present: {
        active: "bg-success text-white border-emerald-500 shadow-md",
        idle: "bg-success-soft text-success border-success-soft hover:border-emerald-300",
        dot: "bg-success",
        chip: "bg-success-soft text-success",
    },
    Absent: {
        active: "bg-danger text-white border-rose-500 shadow-md",
        idle: "bg-danger-soft text-danger border-danger-soft hover:border-rose-300",
        dot: "bg-danger",
        chip: "bg-danger-soft text-danger",
    },
    Excused: {
        active: "bg-warning text-white border-warning shadow-md",
        idle: "bg-warning-soft text-warning border-warning-soft hover:border-amber-300",
        dot: "bg-warning",
        chip: "bg-warning-soft text-warning",
    },
    "Double Session": {
        active: "bg-[#4A6F8F] text-white border-[#4A6F8F] shadow-md",
        idle: "bg-brand-soft text-brand border-brand-soft hover:border-sky-300",
        dot: "bg-brand",
        chip: "bg-brand-soft text-brand",
    },
};
